"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareColumns = prepareColumns;
exports.initRows = initRows;
exports.filterRows = filterRows;
exports.sortRows = sortRows;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("antd/lib/icon"));

var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));

var _columns = _interopRequireDefault(require("./columns"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function nextOrderByDirection(direction) {
  switch (direction) {
    case "ascend":
      return "descend";

    case "descend":
      return null;

    default:
      return "ascend";
  }
}

function toggleOrderBy(columnName) {
  var orderBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var multiColumnSort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var index = (0, _lodash.findIndex)(orderBy, i => i.name === columnName);
  var item = {
    name: columnName,
    direction: "ascend"
  };

  if (index >= 0) {
    item.direction = nextOrderByDirection(orderBy[index].direction);
  }

  if (multiColumnSort) {
    if (!item.direction) {
      return (0, _lodash.filter)(orderBy, i => i.name !== columnName);
    }

    if (index >= 0) {
      orderBy[index] = item;
    } else {
      orderBy.push(item);
    }

    return [...orderBy];
  }

  return item.direction ? [item] : [];
}

function getOrderByInfo(orderBy) {
  var result = {};
  (0, _lodash.each)(orderBy, (_ref, index) => {
    var name = _ref.name,
        direction = _ref.direction;
    result[name] = {
      direction,
      index: index + 1
    };
  });
  return result;
}

function prepareColumns(columns, searchInput, orderBy, onOrderByChange) {
  columns = (0, _lodash.filter)(columns, "visible");
  columns = (0, _lodash.sortBy)(columns, "order");
  var isMultiColumnSort = orderBy.length > 1;
  var orderByInfo = getOrderByInfo(orderBy);
  var tableColumns = (0, _lodash.map)(columns, column => {
    var isAscend = orderByInfo[column.name] && orderByInfo[column.name].direction === "ascend";
    var isDescend = orderByInfo[column.name] && orderByInfo[column.name].direction === "descend";
    var sortColumnIndex = isMultiColumnSort && orderByInfo[column.name] ? orderByInfo[column.name].index : null;
    var result = {
      key: column.name,
      dataIndex: "record[".concat(JSON.stringify(column.name), "]"),
      align: column.alignContent,
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, column.description && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          paddingRight: 5
        }
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "top",
        title: column.description
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "table-visualization-heading"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-info-circle",
        "aria-hidden": "true"
      })))), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "top",
        title: column.title
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "table-visualization-heading",
        "data-sort-column-index": sortColumnIndex
      }, column.title)), /*#__PURE__*/_react.default.createElement("span", {
        className: "ant-table-column-sorter"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        className: "ant-table-column-sorter-up ".concat(isAscend ? "on" : "off"),
        type: "caret-up",
        theme: "filled"
      }), /*#__PURE__*/_react.default.createElement(_icon.default, {
        className: "ant-table-column-sorter-down ".concat(isDescend ? "on" : "off"),
        type: "caret-down",
        theme: "filled"
      })))),
      onHeaderCell: () => ({
        className: (0, _classnames.default)("ant-table-column-has-actions ant-table-column-has-sorters", {
          "table-visualization-column-is-sorted": isAscend || isDescend
        }),
        onClick: event => onOrderByChange(toggleOrderBy(column.name, orderBy, event.shiftKey))
      })
    };
    var initColumn = _columns.default[column.displayAs];
    var Component = initColumn(column);

    result.render = (unused, row) => ({
      children: /*#__PURE__*/_react.default.createElement(Component, {
        row: row.record
      }),
      props: {
        className: "display-as-".concat(column.displayAs)
      }
    });

    return result;
  });
  tableColumns.push({
    key: "###Redash::Visualizations::Table::Spacer###",
    dataIndex: null,
    title: "",
    className: "table-visualization-spacer",
    render: () => "",
    onHeaderCell: () => ({
      className: "table-visualization-spacer"
    })
  });

  if (searchInput) {
    // We need a merged head cell through entire row. With Ant's Table the only way to do it
    // is to add a single child to every column move `dataIndex` property to it and set
    // `colSpan` to 0 for every child cell except of the 1st one - which should be expanded.
    tableColumns = (0, _lodash.map)(tableColumns, (_ref2, index) => {
      var title = _ref2.title,
          align = _ref2.align,
          key = _ref2.key,
          onHeaderCell = _ref2.onHeaderCell,
          rest = _objectWithoutProperties(_ref2, ["title", "align", "key", "onHeaderCell"]);

      return {
        key: key + "(parent)",
        title,
        align,
        onHeaderCell,
        children: [_objectSpread({}, rest, {
          key: key + "(child)",
          align,
          colSpan: index === 0 ? tableColumns.length : 0,
          title: index === 0 ? searchInput : null,
          onHeaderCell: () => ({
            className: "table-visualization-search"
          })
        })]
      };
    });
  }

  return tableColumns;
}

function initRows(rows) {
  return (0, _lodash.map)(rows, (record, index) => ({
    key: "record".concat(index),
    record
  }));
}

function filterRows(rows, searchTerm, searchColumns) {
  if (searchTerm !== "" && searchColumns.length > 0) {
    searchTerm = searchTerm.toUpperCase();
    var matchFields = (0, _lodash.map)(searchColumns, column => {
      var initColumn = _columns.default[column.displayAs];

      var _initColumn = initColumn(column),
          prepareData = _initColumn.prepareData;

      return row => {
        var _prepareData = prepareData(row),
            text = _prepareData.text;

        return (0, _lodash.toString)(text).toUpperCase().indexOf(searchTerm) >= 0;
      };
    });
    return (0, _lodash.filter)(rows, row => (0, _lodash.some)(matchFields, match => match(row.record)));
  }

  return rows;
}

function sortRows(rows, orderBy) {
  if (orderBy.length === 0 || rows.length === 0) {
    return rows;
  }

  var directions = {
    ascend: 1,
    descend: -1
  }; // Create a copy of array before sorting, because .sort() will modify original array

  return [...rows].sort((a, b) => {
    var va;
    var vb;

    for (var i = 0; i < orderBy.length; i += 1) {
      va = a.record[orderBy[i].name];
      vb = b.record[orderBy[i].name];

      if ((0, _lodash.isNil)(va) || va < vb) {
        // if a < b - we should return -1, but take in account direction
        return -1 * directions[orderBy[i].direction];
      }

      if (va > vb || (0, _lodash.isNil)(vb)) {
        // if a > b - we should return 1, but take in account direction
        return 1 * directions[orderBy[i].direction];
      }
    }

    return 0;
  });
}
//# sourceMappingURL=utils.js.map